import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { DownloadButton } from '@components';
import useDashboardExport from '@hooks/useDashboardExport';
import { getPreviousDate, getDateNowServer } from '@utils';
import { validateReportPeriod } from '@utils/reportPeriod';

import {
  Card,
  Title,
  Description,
  Row,
  Fields,
  PeriodLabel,
  Separator,
  DateInput,
  Columns,
} from './Styled';

const ConsolidatedReport = () => {
  const today = getDateNowServer();
  const [dateStart, setDateStart] = useState(getPreviousDate(29));
  const [dateEnd, setDateEnd] = useState(today);
  const { exportConsolidated } = useDashboardExport();

  const handleDownload = async () => {
    const error = validateReportPeriod(dateStart, dateEnd);

    if (error) {
      toast.error(error);
      return;
    }

    await exportConsolidated({ date_start: dateStart, date_end: dateEnd });
  };

  return (
    <Card>
      <Title>Relatório consolidado por aluno</Title>
      <Description>
        Exporte os dados de progresso de todos os seus colaboradores em um
        único arquivo CSV.
      </Description>
      <Row>
        <Fields>
          <PeriodLabel htmlFor="consolidated-date-start">Período:</PeriodLabel>
          <DateInput
            id="consolidated-date-start"
            type="date"
            aria-label="Data inicial"
            value={dateStart}
            max={dateEnd || today}
            onChange={(event) => setDateStart(event.target.value)}
          />
          <Separator>até</Separator>
          <DateInput
            id="consolidated-date-end"
            type="date"
            aria-label="Data final"
            value={dateEnd}
            min={dateStart}
            max={today}
            onChange={(event) => setDateEnd(event.target.value)}
          />
        </Fields>
        <DownloadButton
          label="Baixar CSV"
          onDownload={handleDownload}
          variant="primary"
        />
      </Row>
      <Columns>
        📊 Colunas: Nome, Email, Grupo, Data de Início, Horas de Estudo, Steps
        Concluídos, Lessons Concluídas, Módulos Conquistados, Progresso (%)
      </Columns>
    </Card>
  );
};

export default ConsolidatedReport;
export { ConsolidatedReport };
